import React, { useState } from "react";
import "./profile.scss";

const initialProfile = {
  name: "Admin",
  email: "admin@secondbite.my",
  mobile: "012-3456789",
  role: "Super Administrator",
  language: "English",
  timezone: "Asia/Kuching",
  currentPassword: "",
  newPassword: "",
  confirmPassword: "",
  orderAlert: true,
  vendorAlert: true,
  reportAlert: false,
};

const ProfilePage = () => {
  const [form, setForm] = useState(initialProfile);
  const [saved, setSaved] = useState(false);

  const updateForm = (field, value) => {
    setSaved(false);
    setForm((current) => ({ ...current, [field]: value }));
  };

  const handleSave = (event) => {
    event.preventDefault();
    setSaved(true);
  };

  const renderSwitch = (label, description, field) => (
    <label className="profile-page__switch">
      <input
        type="checkbox"
        checked={Boolean(form[field])}
        onChange={(event) => updateForm(field, event.target.checked)}
      />
      <span>
        <strong>{label}</strong>
        <small>{description}</small>
      </span>
    </label>
  );

  return (
    <form className="profile-page" onSubmit={handleSave}>
      <section className="profile-page__header">
        <div className="profile-page__container profile-page__header-inner">
          <div>
            <p className="profile-page__eyebrow">SecondBite Admin</p>
            <h2>Edit Profile</h2>
            <p>Update your administrator profile, password, and notification preferences.</p>
          </div>

          <button type="submit" className="profile-page__header-action">
            Save Profile
          </button>
        </div>
      </section>

      {saved && (
        <div className="profile-page__notice-wrap">
          <div className="profile-page__container">
            <div className="profile-page__notice" role="status">
              Profile saved for MVP preview. Connect API later.
            </div>
          </div>
        </div>
      )}

      <section className="profile-page__summary-wrap">
        <div className="profile-page__container">
          <div className="profile-page__summary">
            <div className="profile-page__avatar">A</div>
            <div>
              <h3>{form.name}</h3>
              <p>{form.email}</p>
            </div>
            <span>{form.role}</span>
          </div>
        </div>
      </section>

      <div className="profile-page__container">
        <div className="profile-page__grid">
          <section className="profile-page__panel profile-page__panel--wide">
            <div className="profile-page__panel-title">
              <h3>Profile Information</h3>
              <p>Static MVP form. Connect API later.</p>
            </div>

            <div className="profile-page__form-grid">
              <label>
                <span>Full Name</span>
                <input value={form.name} onChange={(event) => updateForm("name", event.target.value)} />
              </label>

              <label>
                <span>Email Address</span>
                <input type="email" value={form.email} onChange={(event) => updateForm("email", event.target.value)} />
              </label>

              <label>
                <span>Mobile Number</span>
                <input value={form.mobile} onChange={(event) => updateForm("mobile", event.target.value)} />
              </label>

              <label>
                <span>Role</span>
                <select value={form.role} onChange={(event) => updateForm("role", event.target.value)}>
                  <option>Super Administrator</option>
                  <option>Administrator</option>
                  <option>Operations</option>
                </select>
              </label>

              <label>
                <span>Language</span>
                <select value={form.language} onChange={(event) => updateForm("language", event.target.value)}>
                  <option>English</option>
                  <option>Malay</option>
                  <option>Chinese</option>
                </select>
              </label>

              <label>
                <span>Timezone</span>
                <select value={form.timezone} onChange={(event) => updateForm("timezone", event.target.value)}>
                  <option>Asia/Kuching</option>
                  <option>Asia/Kuala_Lumpur</option>
                  <option>Asia/Singapore</option>
                </select>
              </label>
            </div>
          </section>

          <section className="profile-page__panel">
            <div className="profile-page__panel-title">
              <h3>Notifications</h3>
              <p>Email alerts for admin activities.</p>
            </div>

            <div className="profile-page__switch-list">
              {renderSwitch("Order Alerts", "Receive email when a new paid order is received.", "orderAlert")}
              {renderSwitch("Vendor Alerts", "Receive email for new vendor setup activity.", "vendorAlert")}
              {renderSwitch("Daily Report", "Receive daily MVP sales summary email.", "reportAlert")}
            </div>
          </section>

          <section className="profile-page__panel">
            <div className="profile-page__panel-title">
              <h3>Account Status</h3>
              <p>Your current admin access summary.</p>
            </div>

            <div className="profile-page__status-list">
              <div>
                <span>Status</span>
                <strong className="profile-page__badge">Active</strong>
              </div>
              <div>
                <span>Last Login</span>
                <strong>Today, 9:25 AM</strong>
              </div>
              <div>
                <span>Created Date</span>
                <strong>12 Jun 2026</strong>
              </div>
            </div>
          </section>

          <section className="profile-page__panel profile-page__panel--wide">
            <div className="profile-page__panel-title">
              <h3>Change Password</h3>
              <p>Leave blank if you do not want to change your password.</p>
            </div>

            <div className="profile-page__form-grid">
              <label>
                <span>Current Password</span>
                <input
                  type="password"
                  value={form.currentPassword}
                  onChange={(event) => updateForm("currentPassword", event.target.value)}
                  placeholder="Enter current password"
                />
              </label>

              <label>
                <span>New Password</span>
                <input
                  type="password"
                  value={form.newPassword}
                  onChange={(event) => updateForm("newPassword", event.target.value)}
                  placeholder="Enter new password"
                />
              </label>

              <label>
                <span>Confirm Password</span>
                <input
                  type="password"
                  value={form.confirmPassword}
                  onChange={(event) => updateForm("confirmPassword", event.target.value)}
                  placeholder="Confirm new password"
                />
              </label>
            </div>
          </section>


        </div>
      </div>

      <div className="profile-page__footer-wrap">
        <div className="profile-page__container profile-page__footer">
          <button type="button" className="profile-page__secondary" onClick={() => setForm(initialProfile)}>
            Reset
          </button>
          <button type="submit" className="profile-page__primary">
            Save Profile
          </button>
        </div>
      </div>
    </form>
  );
};

export default ProfilePage;
